import axios from 'axios'
import {ID} from '../../../../../_metronic/helpers'
import {Account} from '../../account/accounts-list/core/_models'
import {User} from '../../user/users-list/core/_models'
import {AccountsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const ACCOUNT_URL = `${API_URL}/user`

const getAccounts = (query: string): Promise<AccountsQueryResponse> => {
  return axios.get(`${ACCOUNT_URL}?${query}`)
}

const getAccountById = (id: ID): Promise<Account | undefined> => {
  return axios.get(`${ACCOUNT_URL}/${id}`)
}
const getMyAccount = (): Promise<User | undefined> => {
  return axios.get(`${ACCOUNT_URL}/me`)
}

const createAccount = (account: Account): Promise<Account | undefined> => {
  return axios.post(ACCOUNT_URL, account)
}

const updateAccount = (account: Account): Promise<Account | undefined> => {
  return axios.patch(`${ACCOUNT_URL}`, account)
}

const deleteAccount = (accountId: ID): Promise<void> => {
  return axios.delete(`${ACCOUNT_URL}/${accountId}`)
}

const deleteSelectedAccounts = async (accountIds: Array<ID>): Promise<void> => {
  const requests = accountIds.map((id) => axios.delete(`${ACCOUNT_URL}/${id}`))
  await axios.all(requests)
}

export {
  getAccounts,
  deleteAccount,
  deleteSelectedAccounts,
  getAccountById,
  createAccount,
  updateAccount,
  getMyAccount,
}
